var _defs, _g, _circle, _path, _path2, _g2, _g3, _rect, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "132 232 733 570",
    width: 733,
    height: 570,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "gaps"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1024,
    height: 1024,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 348,
    width: 155,
    height: 54,
    rx: 27,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 462,
    width: 132,
    height: 54,
    rx: 27,
    fill: "#000"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#384152",
    mask: "url(#gaps)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 620,
    cy: 478,
    r: 245
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330 232 H620 V348 H330 A58 58 0 0 1 330 232 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326 402 H620 V462 H326 A30 30 0 0 1 326 402 Z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 290,
    r: 58,
    fill: "#384152"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M463 431 L598 296 L683 379 L742 379",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 29,
    strokeLinejoin: "miter",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M758.8 499.9 A66 66 0 1 0 759.3 531.8",
    fill: "none",
    stroke: "#7E8A9B",
    strokeWidth: 40
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#384152"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 646,
    cy: 522,
    r: 70
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576,
    y: 388,
    width: 54,
    height: 134
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#F58035"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M565 397 H608 A12 12 0 0 1 620 409 V522 H585 V425 H565 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M585 522 A61 61 0 1 0 707 522 A61 61 0 1 0 585 522 Z M621 512 A25 25 0 1 0 671 512 A25 25 0 1 0 621 512 Z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 455,
    width: 21,
    height: 40,
    fill: "#384152"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 565,
    cy: 772,
    r: 30,
    fill: "#F58035"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 680,
    cy: 772,
    r: 30,
    fill: "#F58035"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3814746e20183a61b1affe311eefd22c.svg";
export { ForwardRef as ReactComponent };